import { useCallback, useRef, useState } from 'react';

export const useEndOfText = () => {
  const [isEndOfText, setIsEndOfText] = useState(false);
  const cleanupRef = useRef<(() => void) | null>(null);

  const node = useCallback((element: HTMLDivElement | null) => {
    cleanupRef.current?.();
    cleanupRef.current = null;

    if (element) {
      const handleScroll = () => {
        const { scrollHeight, scrollTop, clientHeight } = element;
        const isEndOfText =
          Math.abs(scrollHeight - clientHeight - scrollTop) <= 1;
        setIsEndOfText(isEndOfText);
      };

      element.addEventListener('scroll', handleScroll);
      cleanupRef.current = () =>
        element.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return { isEndOfText, setIsEndOfText, node };
};
